















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderPostModel } from "@/services/render/types";
import {
    ImageIPostProperties,
    ImageItemCSS
} from "@/services/posts/postTypes/image";
import { Style } from "@/services/styles/types";
import ImageSubRender from "@/components/posts/image/ImageSubRender.vue";
import { setNextItem } from "../types";
    @Component({
        components: { ImageSubRender }
    })
export default class ImageRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private active!: number;
    @Prop() private itemStyle!: Style; // it's used only in style form preview
    @Prop() private containerHeight!: number;
    @Prop() private containerWidth!: number;

    properties = this.item.properties;
    reload = false;

    // watcher
    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(
                this.setNextItem,
                this.propertiesModel.showTime * 1000
            );
        }
    }

    @Watch("item") watchModel() {
        if (JSON.stringify(this.properties) !== JSON.stringify(this.propertiesModel)) {
            this.properties = this.propertiesModel;
            this.reload = !this.reload;
        }
    }

    // computed
    get propertiesModel(): ImageIPostProperties {
        return this.item.properties
            ? (this.item.properties as ImageIPostProperties)
            : ({} as ImageIPostProperties);
    }

    get styleModel(): ImageItemCSS {
        return this.item.css &&
                Object.entries(this.item.css).length > 0 &&
                this.item.css.constructor === Object
            ? this.item.css as ImageItemCSS
            : this.itemStyle
                ? this.itemStyle.css as ImageItemCSS
                : {} as ImageItemCSS;
    }

    // methods
    setNextItem() {
        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }
}
